import { GET_VARIABLES } from './types'

export const getVariables = (variablesData) => ({
  type: GET_VARIABLES,
  payload: variablesData,
})
